import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OnlineRegistrationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "OnlineRegistration",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.42 6.11H5.2c-1.77 0-3.19 1.44-3.2 3.21v5.26a3.21 3.21 0 0 0 3.2 3.2h15.71v-1.85H5.2c-.75 0-1.36-.6-1.37-1.35V9.32c0-.76.61-1.38 1.37-1.38h19.22c.76 0 1.37.62 1.37 1.37v2.67l1.82 2.03V9.32c0-1.77-1.43-3.2-3.2-3.21"
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.86 19.32c.04.05.08.11.11.17.09.26-.03.55-.29.65l-2.07.79 1.46 3.82a.49.49 0 0 1-.3.63l-1.26.48c-.26.1-.55-.04-.64-.29l-1.46-3.82-2.07.79c-.06.01-.13.01-.19 0a.49.49 0 0 1-.49-.49v-9.44c0-.15.06-.29.17-.39.21-.18.53-.16.71.05z"
    })]
  }));
};